// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stanceId: __t.u64().primaryKey().name("stance_id"),
  campaignId: __t.u64().name("campaign_id"),
  side: __t.u8(),
  stance: __t.string(),
  sinceRound: __t.u32().name("since_round"),
  reason: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
